<div class="flex items-center justify-center dialog-header ">
    {{type}} Client Package

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <form [formGroup]="packageForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">
        <!-- Existing Client -->
        <div class="flex flex-col">
            <label for="client_id" class="mb-2 font-semibold">Existing Client *</label>
            <p-select
                appendTo="body"
                [options]="clients"
                formControlName="client_id"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Client"
                [filter]="true"
                filterBy="label"
                class="w-full">
            </p-select>
        </div>

        <!-- Package ID -->
        <div class="flex flex-col">
            <label for="package_id" class="mb-2 font-semibold">Package ID *</label>
            <p-select appendTo="body" [options]="allPackages" formControlName="package_id"
                optionLabel="name" optionValue="value"
                placeholder="Select Package ID" class="w-full"></p-select>
        </div>

        <!-- Start Date -->
        <div class="flex flex-col">
            <label for="start_date" class="mb-2 font-semibold">Start Date *</label>
            <p-datepicker 
            appendTo="body"
            [style]="{width: '100%'}"
            id="start_date" formControlName="start_date" dateFormat="yy-mm-dd" class="w-full" />
        </div>

        <!-- End Date -->
        <div class="flex flex-col">
            <label for="end_date" class="mb-2 font-semibold">End Date *</label>
            <p-datepicker
            appendTo="body"
            [style]="{width: '100%'}"
            id="end_date" formControlName="end_date" dateFormat="yy-mm-dd" class="w-full" />
        </div>

        <!-- Reminder Days -->
        <div class="flex flex-col">
            <label for="reminder_before_days" class="mb-2 font-semibold">Reminder Before Days *</label>
            <input pInputText type="number" id="reminder_before_days" formControlName="reminder_before_days"
                class="w-full" />
        </div>

        <!-- Grace Period -->
        <div class="flex flex-col">
            <label for="grace_period" class="mb-2 font-semibold">Grace Period (Days) *</label>
            <input pInputText type="number" id="grace_period" formControlName="grace_period" class="w-full" />
        </div>

        <!-- Auto Renewal -->
        <div class="flex flex-col">
            <label for="auto_renewal" class="mb-2 font-semibold">Auto Renewal</label>
           <p-select appendTo="body" [options]="['Yes', 'No']" formControlName="auto_renewal"
                placeholder="Select Auto Renewal" class="w-full"></p-select>
        </div>

        <!-- Total Users -->
        <div class="flex flex-col">
            <label for="total_user" class="mb-2 font-semibold">Total Users *</label>
            <input pInputText type="number" id="total_user" formControlName="total_user" class="w-full" />
        </div>

        <!-- Status -->
        <div class="flex flex-col">
            <label for="status" class="mb-2 font-semibold">Status *</label>
            <p-select id="status" [options]="statusOptions" formControlName="status" placeholder="Select status"
                class="w-full" />
        </div>

        <!-- Submit Button -->
        <div class="col-span-2 flex justify-end mt-6">
            <p-button label="Submit" type="submit" icon="pi pi-check" [loading]="isLoading"
                [disabled]="packageForm.invalid || isLoading"></p-button>
        </div>
    </form>

</div>